import { motion } from "framer-motion";
import env from "@/assets/images/env.png";
import { Leaf, Droplet, Sprout, Fuel, Cloud } from "lucide-react";

export default function EnvSection() {
  const stats = [
    {
      icon: <Leaf className="w-6 h-6 text-white" />,
      text: "7–10 Kilograms Of Topsoil",
    },
    {
      icon: <Droplet className="w-6 h-6 text-white" />,
      text: "500–1000 Liters Of Water",
    },
    {
      icon: <Sprout className="w-6 h-6 text-white" />,
      text: "0.3–0.5 Grams Of Pesticides",
    },
    {
      icon: <Fuel className="w-6 h-6 text-white" />,
      text: "1–2 Liters Of Fossil Fuel",
    },
    {
      icon: <Cloud className="w-6 h-6 text-white" />,
      text: "3–5 Kilograms Of CO₂ Emissions",
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-linear-to-b from-green-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <motion.div
            className="space-y-6 text-left"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div>
              <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
                Environmental Impact
              </h2>
              <div className="w-16 h-1.5 bg-emerald-500 rounded-full"></div>
            </div>

            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
              Every meal has an environmental footprint. By choosing Mystery
              Bags through
              <span className="font-semibold text-emerald-700">
                {" "}
                SMARTLY ORDERS
              </span>
              , you're not only saving money—you’re also helping reduce food
              waste and conserving valuable natural resources that go into
              producing every meal.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
              {stats.map((item, index) => (
                <motion.div
                  key={index}
                  className="flex items-center space-x-4 p-4 bg-slate-50 rounded-xl border border-slate-100"
                  initial={{ opacity: 0, scale: 0.8, y: 30 }}
                  whileInView={{ opacity: 1, scale: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.2,
                    ease: "easeOut",
                  }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-emerald-600 shadow-sm flex-shrink-0">
                    {item.icon}
                  </div>
                  <p className="text-sm font-semibold text-slate-800">
                    {item.text}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right side - Image */}
          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="w-full max-w-md rounded-lg overflow-hidden">
              <motion.img
                src={env}
                alt="Environmental Impact"
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 200 }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
